import { memo, type ReactNode } from "react";
import slotEmptyImg from "../assets/images/slot-empty.webp";
import slotWithItemImg from "../assets/images/slot-with-item.webp";
import slotUnavailableImg from "../assets/images/slot-unavailable.webp";
import activeImg from "../assets/images/slot-active.webp";

export type SlotState = "empty" | "with-item" | "unavailable" | "active";

const BG_IMAGE: Record<SlotState, string> = {
  empty: slotEmptyImg,
  "with-item": slotWithItemImg,
  unavailable: slotUnavailableImg,
  active: activeImg,
};

interface Props {
  state: SlotState;
  children?: ReactNode;
}

export const SlotBackground = memo(function SlotBackground({ state, children }: Props) {
  return (
    <div className="relative w-full h-full rounded-md">
      <img
        src={BG_IMAGE[state]}
        alt=""
        className="absolute inset-0 w-full h-full object-fill pointer-events-none select-none select-none"
        draggable={false}
      />
      <div className="relative w-full h-full">{children}</div>
    </div>
  );
});
